export default {
  edit (aModel) {
    this.editRelation('graves', aModel)
  },

  delete (aModel) {
    this.deleteRelation('graves', aModel)
  }
}



// WEBPACK FOOTER //
// ./src/functions/grave.js